import { UserKeyPromptService } from './user-key-prompt-service';
export class StatefulUserKeyPromptService extends UserKeyPromptService {
    constructor(uiFrameAdapter, userKeysRepository, keyVaultService, companyKeyService, cryptoService, vaultRequestRepository, logger, localStorage) {
        super(uiFrameAdapter, userKeysRepository, keyVaultService, companyKeyService, cryptoService, vaultRequestRepository, logger, localStorage);
    }
    async promptForKeyWithRetry(options, operation) {
        await this.loadUserKey(options);
        await operation(...this.ztOperationParameters);
    }
    async loadUserKey(options) {
        if (this.ztOperationParameters)
            return;
        await super.promptForKeyWithRetry(options, async (...operationParameters) => {
            this.ztOperationParameters = operationParameters;
        });
    }
}
